if (!customElements.get('rd-kit-packing')) {
  customElements.define('rd-kit-packing', class extends HTMLElement {
    connectedCallback() {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const firstFlight = this.querySelector('[data-first-flight]');
      if (!firstFlight?.beginElement) return;

      this.events = new AbortController();
      const { signal } = this.events;
      let visible = false;
      let ready = false;
      const play = () => {
        if (signal.aborted || !visible || !ready || document.hidden || reducedMotion.matches || this.classList.contains('is-packing')) return;

        // Commit the class removal before starting the next CSS and SVG cycle together.
        void this.offsetWidth;
        this.classList.add('is-packing');
        firstFlight.beginElement();
      };

      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.intersectionRatio >= 0.5;
        play();
      }, { threshold: 0.5 });
      this.observer = observer;
      observer.observe(this);

      this.addEventListener('animationend', (event) => {
        if (event.target !== this || event.animationName !== 'rd-kit-teaser-light-sweep') return;
        this.classList.remove('is-packing');
        play();
      }, { signal });
      document.addEventListener('visibilitychange', play, { signal });
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) this.classList.remove('is-packing');
        else play();
      }, { signal });

      const sprites = Array.from(this.querySelectorAll('defs image'), (asset) => {
        const image = new Image();
        image.src = asset.getAttribute('href');
        return image.decode();
      });
      Promise.allSettled(sprites).then(() => {
        ready = true;
        play();
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.classList.remove('is-packing');
    }
  });
}
